import { apiService } from '../api';
import {
  TwoFactorSecretResponseType,
  VerifyAndEnableTwoFactorRequest,
  VerifyAndEnableTwoFactorResponse,
  VerifyTwoFactorTokenRequest,
  VerifyTwoFactorTokenResponse,
  SkipTwoFactorResponse,
  DisableTwoFactorRequest,
  DisableTwoFactorResponse,
} from '@/types/auth';

export class TwoFactorService {
  private static instance: TwoFactorService;

  private constructor() {}

  public static getInstance(): TwoFactorService {
    if (!TwoFactorService.instance) {
      TwoFactorService.instance = new TwoFactorService();
    }
    return TwoFactorService.instance;
  }

  public async generateSecret(): Promise<TwoFactorSecretResponseType> {
    return apiService.get<TwoFactorSecretResponseType>(
      '/private/api/v1/auth/two-factor/generate-secret',
    );
  }

  public async verifyAndEnable(
    request: VerifyAndEnableTwoFactorRequest,
  ): Promise<VerifyAndEnableTwoFactorResponse> {
    return apiService.post<
      VerifyAndEnableTwoFactorResponse,
      VerifyAndEnableTwoFactorRequest
    >('/private/api/v1/auth/two-factor/verify-enable', request);
  }

  public async skip(): Promise<SkipTwoFactorResponse> {
    return apiService.post<SkipTwoFactorResponse, Record<string, never>>(
      '/private/api/v1/auth/two-factor/skip',
      {},
    );
  }

  public async disable(
    data: DisableTwoFactorRequest,
  ): Promise<DisableTwoFactorResponse> {
    return apiService.post<DisableTwoFactorResponse, DisableTwoFactorRequest>(
      '/private/api/v1/auth/two-factor/disable',
      data,
    );
  }

  public async verifyToken(
    data: VerifyTwoFactorTokenRequest,
  ): Promise<VerifyTwoFactorTokenResponse> {
    return apiService.post<
      VerifyTwoFactorTokenResponse,
      VerifyTwoFactorTokenRequest
    >('/private/api/v1/auth/two-factor/verifyToken', data);
  }
}

export const twoFactorService = TwoFactorService.getInstance();
